import housingTypeConstructor from './housingTypeConstructor';

/**
 * The function `getHousingType` takes an array of housing elements and returns an object containing
 * housing types, where each option  is associated with a housing type.
 * @param housingElements - The `housingElements` parameter is an array of DOM elements representing
 * housing boxes. Each element should have a `data-housing-type` attribute that specifies the type of
 * housing.
 * @returns an object called `housingBoxes` which contains housing types as keys and the result of
 * calling the `housingBoxConstructor` function with the housing type as the argument as values.
 */
function getHousingType(housingElements) {
  const housingTypeOptions = {};
  housingElements.forEach((option) => {
    const housingType = option.dataset.housingType;
    housingTypeOptions[housingType] = housingTypeConstructor(housingType);
  });

  return housingTypeOptions;
}

export default getHousingType;
